export default __webpack_public_path__ + "static/media/Stage3.2d5b5b7b.svg";